// FX Capital India — Bill Management front-end configuration
//
// This file auto-detects whether it's running locally or on the live server.
// You do NOT need to edit this file when switching between dev and production.
//
//   Running on localhost:3000  =>  API = http://localhost:5036   (your local backend)
//   Running on trm.fxcapitalindia.in  =>  API = https://trm.fxcapitalindia.in/api  (live backend)
//
// AUTH_API always points to fx.fxcapitalindia.in (single source of truth for logins)

const isLocal =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' ||
   window.location.hostname === '127.0.0.1');

const CONFIG = {
  API:              isLocal ? 'http://localhost:5036'         : 'https://trm.fxcapitalindia.in/api',
  AUTH_API:         'https://fx.fxcapitalindia.in/api',
  GOOGLE_CLIENT_ID: '389151961632-mjjm15kqanvpkeaosqp0to2i86rsf0qf.apps.googleusercontent.com'
};

// Small console note so you can see which backend the app is talking to
if (typeof window !== 'undefined' && window.console) {
  console.log(
    `%c[FX Capital] API target: ${CONFIG.API}`,
    isLocal
      ? 'color: #10b981; font-weight: bold;'
      : 'color: #6b7280; font-weight: bold;'
  );
}

export default CONFIG;